<script setup>
import { computed } from "vue"
import Global from '../../js/constant.js'
import FooterNavigation from './FooterNavigation.vue'

// computed
const pc = computed(() => {
  return Global.device_division_id.pc
});

(()=>{
  // console.log('created')
})();
</script>
<template>
  <footer><a href=""><img src="/assets/logo.svg" alt="ともつくネット"></a>
    <FooterNavigation :mode="pc" />
    <p>Copyright ©megurinowa.Inc All Rights Reserved.</p>
    <p>vue3.2</p>
  </footer>
</template>

